module.exports = __webpack_public_path__ + "media/images/flags/1x1/swe-0dab8df9c7d564dfe96389443aca5c45.svg";